import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '@core/shared';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import {
  UrlBuilder,
} from '@core/core-api-variables';
import {
  GET_PENDING_USERS, UPDATE_APPROVE_STATUS, UPDATE_REJECT_STATUS, GET_AWF_LEVEL, DOWNLOAD_PENDING_USERS
} from '../extensions-api-variables';
import {userApprovalSearchCriteria} from '@app/extension/models/userAddressDetail.model'
import { ParamsBuilderService } from '@app/core/shared/services/params-builder.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

    constructor(public http: HttpService, public httpClient: HttpClient, public paramsBuilderService: ParamsBuilderService) { }

  getUsers(userSearchCriteria: userApprovalSearchCriteria): Observable<any> {
      let params = this.paramsBuilderService.buildParams(userSearchCriteria);
      let data = { params };
      let url = UrlBuilder(GET_PENDING_USERS, data);
      return this.http.get(url).pipe(map((response: any) => {
          return response;
      }));
    }
  downLoadUsers(userSearchCriteria: userApprovalSearchCriteria): Observable<any> {
      let params = this.paramsBuilderService.buildParams(userSearchCriteria);
      let data = { params };
      let url = UrlBuilder(DOWNLOAD_PENDING_USERS, data);

      let httpOptions = {
          responseType: 'arraybuffer', observe: 'response'
      }
      return this.http.get(url, httpOptions).pipe(map((response: any) => {
          return response;
      }));
  }
  
  getAwfLevel(): Observable<any> {
    let url = GET_AWF_LEVEL;
    return this.http.get(url).pipe(map((response: any) => {
        return response;
    }));
}

  updateapprove(UserId): Observable<any> {
      let url = UPDATE_APPROVE_STATUS;
      let payload = { UserId: UserId };
      return this.http.put(url,payload).pipe(map((response: any) => {
          return response;
      }));
  }

  updatereject(UserId): Observable<any> {
    let url = UPDATE_REJECT_STATUS;
    let payload = { UserId: UserId };
    return this.http.put(url, payload).pipe(map((response: any) => {
        return response;
    }));
}

}
